/**
 * Styled confirmation modal component
 */

import React from 'react';
import Button from './Button';
import Modal from './Modal';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
  disableBackdropClick?: boolean;
  modal?: boolean | 'trap-focus';
  children?: React.ReactNode;
}

export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'warning',
  isLoading = false,
  disableBackdropClick = false,
  modal = true,
  children
}: ConfirmModalProps) {
  const buttonVariants = {
    danger: 'danger' as const,
    warning: 'primary' as const,
    info: 'primary' as const
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      className="w-full max-w-md"
      disableBackdropClick={disableBackdropClick}
      modal={modal}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-gray-600">{message}</p>
        {children}
        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button onClick={onClose} variant="outline" text={cancelText} disabled={isLoading} />
          <Button
            onClick={onConfirm}
            variant={buttonVariants[variant]}
            text={confirmText}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}
